module.exports = __webpack_public_path__ + "img/big_asset.550d6046.svg";